import { diagnoseNetworkError } from "./NetworkError";

export class AsyncLoadIntoDocument {
    public static script(uri: string): Promise<void> {
        const head = document.getElementsByTagName("head")[0] || document.documentElement;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const script: any = document.createElement("script");

        const { promise, resolve, reject } = createPromiseWithResolvers();

        function loadHandler(): void {
            const scriptLoaded =
                !script.readyState || script.readyState === "loaded" || script.readyState === "complete";
            if (scriptLoaded) {
                resolve();
            }
        }

        // NOTE(user): This callback will be called in IE even upon error. In any
        // case it is the client's responsibility to verify that the script ran
        // successfully.
        script.onload = loadHandler;
        script.onreadystatechange = loadHandler;

        // NOTE(user): Not supported in IE.
        script.onerror = async () => {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }

            // используем доп запрос для получения инфы об ошибке
            const networkError = await diagnoseNetworkError(uri);
            reject(networkError);
        };

        // NOTE(user): Safari never loads the script if we don't set
        // the src attribute before appending.
        script.src = uri;
        head.appendChild(script);

        return promise;
    }

    public static styleSheet(uri: string, ignoreError: boolean = false): Promise<void> {
        const head = document.getElementsByTagName("head")[0] ?? document.documentElement;
        const link = document.createElement("link");

        link.setAttribute("rel", "stylesheet");
        link.setAttribute("type", "text/css");
        link.setAttribute("href", uri);

        const { promise, resolve, reject } = createPromiseWithResolvers();
        link.addEventListener("load", resolve);
        link.addEventListener("error", () => {
            if (ignoreError) {
                resolve();
            } else {
                reject();
            }
        });

        head.appendChild(link);

        return promise;
    }
}

type Resolve = () => void;
type Reject = (reason?: unknown) => void;

const createPromiseWithResolvers = () => {
    let resolve: Resolve;
    let reject: Reject;
    const promise = new Promise<void>((res, rej) => {
        resolve = res;
        reject = rej;
    });

    // @ts-expect-error переменные будут проинициализированы
    return { promise: promise, resolve: resolve, reject: reject };
};
